<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <!-- 主表单区域 -->
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-item :label="$t('label.company')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                disabled
                :trigger-change="true"
                dictCode="sys_depart,depart_name,org_code,org_category='1' and del_flag='0'"
                v-decorator="[
                  'companyCode',
                  { initialValue: initCompanyCode, rules: validatorRules.companyCode.rules },
                ]"
                type="list"
                :placeholder="$t('label.pleaseSelectCompany')"
              />
              <!--<a-input v-decorator="['companyCode']" placeholder="请输入公司编码"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.category')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                :trigger-change="true"
                v-decorator="['breedVarietyCode', validatorRules.breedVarietyCode]"
                type="list"
                @change="handleBreedClass"
                dictCode="sys_category,name,code,pid=(select id from sys_category where code='A01' AND name = '物种分类')"
                :placeholder="$t('label.pleaseSelectCategory')"
              />
              <!--          <a-input v-decorator="['breedVarietyCode']" placeholder="请输入品类编码"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.breedingStrain')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                :trigger-change="true"
                :dictCode="dictBreedStrainCode"
                v-decorator="['breedStrainCode', validatorRules.breedStrainCode]"
                type="list"
                :placeholder="$t('label.pleaseSelectBreed')"
                @change="versionChange"
              />
              <!-- <a-input v-decorator="['breedStrainCode']" placeholder="请输入品系编码"></a-input>-->
            </a-form-item>
          </a-col>
          <!--<a-col :span="12" >
            <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['remarks']" :placeholder="$t('label.pleaseEnterANote')"></a-input>
            </a-form-item>
          </a-col>-->
          <!-- <a-col :span="12" >
            <a-form-item :label="$t('label.validOrNot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['validFlag']" placeholder="请输入是否有效"></a-input>
            </a-form-item>
          </a-col>-->
          <a-col :span="12">
            <a-form-item :label="$t('label.version')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['version', validatorRules.version]" :placeholder="$t('label.pleaseEnterTheVersion')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.defaultVersion')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-radio-group v-decorator="['defaultFlag', { initialValue: 'Y' }]">
                <a-radio value="Y">{{$t('label.yes')}}</a-radio>
                <a-radio value="N">{{$t('label.no')}}</a-radio>
              </a-radio-group>
              <!-- <a-input v-decorator="['defaultFlag']" placeholder="请输入默认版本"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.effectiveDate')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date
                :placeholder="$t('label.pleaseSelectEffectiveDate')"
                :disabled="postDateDisabled"
                v-decorator="['postDate', { initialValue: initPostDate, rules: validatorRules.postDate.rules }]"
                :trigger-change="true"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
    <!-- 子表单区域 -->
    <a-tabs v-model="activeKey" @change="handleChangeTabs">
      <a-tab-pane :tab="$t('tabName.feedingStandards')" :key="refKeys[0]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[0]"
          :tableName="subTable[0]"
          :loading="efsStdCompanyFeedingDetailTable.loading"
          :columns="efsStdCompanyFeedingDetailTable.columns"
          :dataSource="efsStdCompanyFeedingDetailTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="true"
          @valueChange="handleValueChange"
        />
      </a-tab-pane>
      <a-tab-pane :tab="$t('tabName.immunizationStandards')" :key="refKeys[1]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[1]"
          :tableName="subTable[1]"
          :loading="efsStdCompanyImmunityDetailTable.loading"
          :columns="efsStdCompanyImmunityDetailTable.columns"
          :dataSource="efsStdCompanyImmunityDetailTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="true"
          @valueChange="handleValueChangeNew"
        />
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>
import pick from 'lodash.pick'
import { getAction } from '@/api/manage'
import { FormTypes, getRefPromise } from '@/utils/JEditableTableUtil'
import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
import { validateDuplicateValue } from '@/utils/util'
import JFormContainer from '@/components/jeecg/JFormContainer'
import JDate from '@/components/jeecg/JDate'
import { getMaterialInfoByMmCode, getMmListNoPage, ajaxGetDictItems, getCurrentUser, getVersion } from '@/api/api'
import moment from 'moment'

export default {
  name: 'EfsStdCompanyStandardForm',
  mixins: [JEditableTableMixin],
  components: {
    JFormContainer,
    JDate,
  },
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
      // 新增时子表默认添加几行空数据
      addDefaultRowNum: 1,
      validatorRules: {
        companyCode: { rules: [{ required: true, message: this.$t('label.pleaseSelectCompany') }] },
        breedVarietyCode: { rules: [{ required: true, message: this.$t('label.pleaseSelectCategory') }] },
        breedStrainCode: { rules: [{ required: true, message: this.$t('label.pleaseSelectBreed') }] },
        version: { rules: [{ required: true, message: this.$t('label.pleaseEnterTheVersion') }] },
        postDate: {
          rules: [{ required: true, message: this.$t('label.pleaseSelectEffectiveDate') }],
        },
      },
      refKeys: ['efsStdCompanyFeedingDetail', 'efsStdCompanyImmunityDetail'],
      tableKeys: ['efsStdCompanyFeedingDetail', 'efsStdCompanyImmunityDetail'],
      activeKey: 'efsStdCompanyFeedingDetail',
      // efs_std_company_feeding_detail
      efsStdCompanyFeedingDetailTable: {
        loading: false,
        dataSource: [],
        columns: [
          {
            title: this.$t('tableHeader.dayAge'),
            // title: '日龄',
            key: 'days',
            type: FormTypes.inputNumber,
            width: '80px',
            placeholder: this.$t('tip.pleaseInput') + '${title}',
            defaultValue: '',
            validateRules: [
              {
                required: true, // 必填
                message: this.$t('tip.pleaseInput') + '${title}', // 提示的文本
              },
            ],
          },
          {
            title: this.$t('tableHeader.weekAge'),
            // title: '周龄',
            key: 'weeks',
            type: FormTypes.inputNumber,
            width: '80px',
            disabled: true,
            placeholder: this.$t('tip.pleaseInput') + '${title}',
            defaultValue: '',
            validateRules: [
              {
                required: true, // 必填
                message: this.$t('tip.pleaseInput') + '${title}', // 提示的文本
              },
            ],
          },
          {
            title: this.$t('tableHeader.materialCode'),
            // title: '物料编号',
            key: 'mmCode',
            type: FormTypes.sel_search,
            mmCode: true,
            width: '200px',
            allowSearch: true,
            placeholder: this.$t('tip.pleaseSelect') + '${title}',
            validateRules: [
              {
                required: true, // 必填
                message: this.$t('tip.pleaseSelect') + '${title}', // 提示的文本
              },
            ],
          },
          {
            title: this.$t('tableHeader.materialName'),
            // title: '物料名称',
            key: 'mmName',
            type: FormTypes.normal,
            width: '400px',
          },
          {
            title: this.$t('tableHeader.feedingAmount'),
            // title: '饲喂量/g',
            key: 'feedAmount',
            type: FormTypes.inputNumber,
            width: '200px',
            placeholder: this.$t('tip.pleaseInput') + '${title}',
            defaultValue: '',
            validateRules: [
              {
                required: true, // 必填
                message: this.$t('tip.pleaseInput') + '${title}', // 提示的文本
              },
            ],
          },
        ],
      },
      // efs_std_company_immunity_detail
      efsStdCompanyImmunityDetailTable: {
        loading: false,
        dataSource: [],
        columns: [
          {
            title: this.$t('tableHeader.dayAge'),
            // title: '日龄',
            key: 'days',
            type: FormTypes.inputNumber,
            width: '80px',
            placeholder: this.$t('tip.pleaseInput') + '${title}',
            defaultValue: '',
            validateRules: [
              {
                required: true, // 必填
                message: this.$t('tip.pleaseInput') + '${title}', // 提示的文本
              },
            ],
          },
          {
            title: this.$t('tableHeader.weekAge'),
            // title: '周龄',
            key: 'weeks',
            type: FormTypes.inputNumber,
            width: '80px',
            disabled: true,
            placeholder: this.$t('tip.pleaseInput') + '${title}',
            defaultValue: '',
            validateRules: [
              {
                required: true, // 必填
                message: this.$t('tip.pleaseInput') + '${title}', // 提示的文本
              },
            ],
          },
          {
            title: this.$t('tableHeader.target'),
            // title: '目标',
            key: 'immunizationTarget',
            type: FormTypes.input,
            width: '200px',
            placeholder: this.$t('tip.pleaseInput') + '${title}',
            defaultValue: '',
            validateRules: [
              {
                required: true, // 必填
                message: this.$t('tip.pleaseInput') + '${title}', // 提示的文本
              },
            ],
          },
          {
            title: this.$t('tableHeader.materialCode'),
            // title: '物料编号',
            key: 'mmCode',
            type: FormTypes.sel_search,
            mmCode: true,
            width: '200px',
            allowSearch: true,
            placeholder: this.$t('tip.pleaseSelect') + '${title}',
            validateRules: [
              {
                required: true, // 必填
                message: this.$t('tip.pleaseSelect') + '${title}', // 提示的文本
              },
            ],
          },
          {
            title: this.$t('tableHeader.materialName'),
            // title: '物料名称',
            key: 'mmName',
            type: FormTypes.normal,
            width: '400px',
          },
          {
            title: this.$t('tableHeader.usage'),
            // title: '用法',
            key: 'usefulness',
            type: FormTypes.input,
            width: '100px',
            placeholder: this.$t('tip.pleaseInput') + '${title}',
            defaultValue: '',
            validateRules: [
              {
                required: true, // 必填
                message: this.$t('tip.pleaseInput') + '${title}', // 提示的文本
              },
            ],
          },
          {
            title: this.$t('tableHeader.quantityUsed'),
            // title: '用量',
            key: 'measure',
            type: FormTypes.input,
            width: '100px',
            placeholder: this.$t('tip.pleaseInput') + '${title}',
            defaultValue: '',
            validateRules: [
              {
                required: true, // 必填
                message: this.$t('tip.pleaseInput') + '${title}', // 提示的文本
              },
            ],
          },
          {
            title: this.$t('tableHeader.unit'),
            // title: '单位',
            key: 'unit',
            type: FormTypes.input,
            width: '100px',
            placeholder: this.$t('tip.pleaseInput') + '${title}',
            defaultValue: '',
            validateRules: [
              {
                required: true, // 必填
                message: this.$t('tip.pleaseInput') + '${title}', // 提示的文本
              },
            ],
          },
        ],
      },
      url: {
        add: '/companyStandard/efsStdCompanyStandard/add',
        edit: '/companyStandard/efsStdCompanyStandard/edit',
        queryById: '/companyStandard/efsStdCompanyStandard/queryById',
        efsStdCompanyFeedingDetail: {
          list: '/companyStandard/efsStdCompanyStandard/queryEfsStdCompanyFeedingDetailByMainId',
        },
        efsStdCompanyImmunityDetail: {
          list: '/companyStandard/efsStdCompanyStandard/queryEfsStdCompanyImmunityDetailByMainId',
        },
        queryMaterials: '/companyStandard/efsStdCompanyStandard/queryMaterials',
      },
      initCompanyCode: null,
      dictBreedStrainCode: '',
      postDateDisabled: false,
      initPostDate: moment(new Date()).format('YYYY-MM-DD'),
      disableSubmit: true,
      mainTable: 'efs_std_company_standard',
      subTable: ['efs_std_company_feeding_detail', 'efs_std_company_immunity_detail'],
    }
  },
  props: {
    //流程表单data
    formData: {
      type: Object,
      default: () => {},
      required: false,
    },
    //表单模式：false流程表单 true普通表单
    formBpm: {
      type: Boolean,
      default: false,
      required: false,
    },
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    formDisabled() {
      if (this.formBpm === true) {
        if (this.formData.disabled === false) {
          return false
        }
        return true
      }
      return this.disabled
    },
    showFlowSubmitButton() {
      if (this.formBpm === true) {
        if (this.formData.disabled === false) {
          return true
        }
      }
      return false
    },
  },
  created() {
    //如果是流程中表单，则需要加载流程表单data
    this.showFlowData()
    getCurrentUser().then((res) => {
      if (res.success) {
        this.initCompanyCode = res.result.orgCode
      }
    })
  },
  methods: {
    addBefore() {
      this.form.resetFields()
      this.efsStdCompanyFeedingDetailTable.dataSource = []
      this.efsStdCompanyImmunityDetailTable.dataSource = []
    },
    getAllTable() {
      let values = this.tableKeys.map((key) => getRefPromise(this, key))
      return Promise.all(values)
    },
    /** 调用完edit()方法之后会自动调用此方法 */
    editAfter() {
      let fieldval = pick(
        this.model,
        'code',
        'companyCode',
        'breedVarietyCode',
        'breedStrainCode',
        'version',
        'remarks',
        'approvalStatus',
        'applicant',
        'applyTime',
        'lastApprover',
        'lastApproveTime',
        'buffer1',
        'buffer2',
        'buffer3',
        'buffer4',
        'buffer5',
        'buffer6',
        'buffer7',
        'buffer8',
        'buffer9',
        'buffer10',
        'validFlag',
        'delFlag',
        'createBy',
        'createTime',
        'updateBy',
        'updateTime',
        'sysOrgCode',
        'defaultFlag',
        'postDate'
      )
      this.$nextTick(() => {
        this.form.setFieldsValue(fieldval)
      })
      // this.getImmunity();
      // this.getMaterial();
      // 加载子表数据
      if (this.model.id) {
        this.dictBreedStrainCode =
          "sys_category,name,code,pid=(select id from sys_category where code= '" + this.model.breedVarietyCode + "')"
        //this.handleBreedClass(this.model.breedVarietyCode);
        //饲喂标准饲料传0
        this.handleChooseFeed('0')
        //免疫标准药品传1
        this.handleChooseFeed('1')
        let params = { id: this.model.id }
        this.requestSubTableData(this.url.efsStdCompanyFeedingDetail.list, params, this.efsStdCompanyFeedingDetailTable)
        this.requestSubTableData(
          this.url.efsStdCompanyImmunityDetail.list,
          params,
          this.efsStdCompanyImmunityDetailTable
        )
        this.postDateDisabled = true
      } else {
        this.postDateDisabled = false
        //饲喂标准饲料传0
        this.handleChooseFeed('0')
        //免疫标准药品传1
        this.handleChooseFeed('1')
        this.dictBreedStrainCode = ''
      }
    },
    getSubTableSubData(dataSource, tab) {
      // 拿到下边表数据渲染上边form
      let newDataSource = dataSource
      newDataSource.map((item) => {
        item.mmCode = this.emptySelect(item.mmCode)
      })
      tab.dataSource = newDataSource
    },
    /** 整理成formData */
    classifyIntoFormData(allValues) {
      let main = Object.assign(this.model, allValues.formValue)
      return {
        ...main, // 展开
        efsStdCompanyFeedingDetailList: allValues.tablesValue[0].values,
        efsStdCompanyImmunityDetailList: allValues.tablesValue[1].values,
      }
    },
    //渲染流程表单数据
    showFlowData() {
      if (this.formBpm === true) {
        let params = { id: this.formData.dataId }
        getAction(this.url.queryById, params).then((res) => {
          if (res.success) {
            this.edit(res.result)
          }
        })
      }
    },
    validateError(msg) {
      this.$message.error(msg)
    },
    // getMmNo() {
    //   getMmListNoPage({mmGrpCode: '21,31,42'}).then((res) => {
    //     if (res.success) {
    //       let newobj = {}
    //       let arr = res.result.reduce((preVal, curVal) => {
    //         newobj[curVal.code] ? '' : newobj[curVal.code] = preVal.push(curVal);
    //         return preVal
    //       }, [])
    //       let relRes = []
    //       arr.map(item => {
    //         relRes.push({
    //           label: item.code,
    //           option: item.code + '|' + item.name,
    //           value: item.code,
    //         })
    //       })
    //       this.efsStdCompanyFeedingDetailTable.columns[2].options = relRes;
    //     }
    //   })
    // },
    getMaterial() {
      let dictCode =
        "efs_md_material,CONCAT(code((comma))((verticalLine))((comma))name),code, mm_grp_code IN (select code from efs_md_mm_group where category='10' and valid_flag='Y' and del_flag='N') and valid_flag='Y' and del_flag='N' order by code asc"

      ajaxGetDictItems(dictCode, null).then((res) => {
        if (res.success) {
          let newobj = {}
          let arr = res.result.reduce((preVal, curVal) => {
            newobj[curVal.value] ? '' : (newobj[curVal.value] = preVal.push(curVal))
            return preVal
          }, [])
          let relRes = []
          arr.map((item) => {
            relRes.push({
              // label: item.value,
              label: item.value,
              value: item.value,
              option: item.text,
            })
          })
          this.efsStdCompanyFeedingDetailTable.columns[2].options = relRes
        }
      })
    },
    getImmunity() {
      let dictCode =
        "efs_md_material,CONCAT(code((comma))((verticalLine))((comma))name((comma))((verticalLine))((comma))oem),code, mm_grp_code IN (select code from efs_md_mm_group where category='12' and valid_flag='Y' and del_flag='N')  and valid_flag='Y' and del_flag='N' order by code asc"

      ajaxGetDictItems(dictCode, null).then((res) => {
        if (res.success) {
          let newobj = {}
          let arr = res.result.reduce((preVal, curVal) => {
            newobj[curVal.value] ? '' : (newobj[curVal.value] = preVal.push(curVal))
            return preVal
          }, [])
          let relRes = []
          arr.map((item) => {
            relRes.push({
              // label: item.value,
              label: item.value,
              value: item.value,
              option: item.text,
            })
          })
          this.efsStdCompanyImmunityDetailTable.columns[3].options = relRes
        }
      })
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'code',
          'companyCode',
          'breedVarietyCode',
          'breedStrainCode',
          'version',
          'remarks',
          'approvalStatus',
          'applicant',
          'applyTime',
          'lastApprover',
          'lastApproveTime',
          'buffer1',
          'buffer2',
          'buffer3',
          'buffer4',
          'buffer5',
          'buffer6',
          'buffer7',
          'buffer8',
          'buffer9',
          'buffer10',
          'validFlag',
          'delFlag',
          'createBy',
          'createTime',
          'updateBy',
          'updateTime',
          'sysOrgCode',
          'defaultFlag',
          'postDate'
        )
      )
    },
    handleChooseFeed(type) {
      getAction(this.url.queryMaterials, { type: type }).then((res) => {
        if (res.success) {
          let allOptions = res.result || []
          let options = []
          if (allOptions && allOptions.length) {
            if (type == '0') {
              allOptions.map((item) => {
                options.push({
                  label: this.emptySelect(item.code),
                  value: item.code,
                  option: this.emptySelect(item.code + '|' + item.name),
                })
              })
            } else {
              allOptions.map((item) => {
                options.push({
                  label: this.emptySelect(item.code),
                  value: item.code,
                  option: this.emptySelect(item.code + '|' + item.name + '|' + item.oem),
                })
              })
            }
          }
          if (type == '0') {
            this.efsStdCompanyFeedingDetailTable.columns[2].options = options
            this.$refs.efsStdCompanyFeedingDetail.$forceUpdate()
          } else {
            this.efsStdCompanyImmunityDetailTable.columns[3].options = options
            this.$refs.efsStdCompanyImmunityDetail.$forceUpdate()
          }
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    handleValueChange(event) {
      const { type, row, column, value, target } = event
      if (event.column.key === 'days') {
        // 计算周龄  日龄/7 按进一法取整
        let weeks = Math.ceil(event.row.days / 7)
        this.$refs.efsStdCompanyFeedingDetail.setValues([
          {
            rowKey: event.row.id,
            values: {
              weeks: weeks,
            },
          },
        ])
        this.$refs.efsStdCompanyFeedingDetail.$forceUpdate()
      } else if (event.column.mmCode === true) {
        getMaterialInfoByMmCode({ mmCode: event.row.mmCode }).then((res) => {
          if (res.success) {
            this.$refs.efsStdCompanyFeedingDetail.setValues([
              {
                rowKey: event.row.id,
                values: {
                  mmName: res.result.name,
                },
              },
            ])
            this.$refs.efsStdCompanyFeedingDetail.$forceUpdate()
          }
        })
      }
      // if (column.key === 'mmCode') {
      //
      //       this.$refs.efsStdCompanyFeedingDetail.setValues([
      //           {
      //               rowKey: event.row.id,
      //               values: {
      //                   mmCode: value
      //               }
      //           }
      //       ])
      //       this.$refs.efsStdCompanyFeedingDetail.$forceUpdate()
      //   }
    },
    handleValueChangeNew(event) {
      if (event.column.key === 'days') {
        // 计算周龄  日龄/7 按进一法取整
        let weeks = Math.ceil(event.row.days / 7)
        this.$refs.efsStdCompanyImmunityDetail.setValues([
          {
            rowKey: event.row.id,
            values: {
              weeks: weeks,
            },
          },
        ])
        this.$refs.efsStdCompanyImmunityDetail.$forceUpdate()
      } else if (event.column.mmCode === true) {
        getMaterialInfoByMmCode({ mmCode: event.row.mmCode }).then((res) => {
          if (res.success) {
            this.$refs.efsStdCompanyImmunityDetail.setValues([
              {
                rowKey: event.row.id,
                values: {
                  mmName: res.result.name,
                },
              },
            ])
            this.$refs.efsStdCompanyImmunityDetail.$forceUpdate()
          }
        })
      }
    },
    handleBreedClass(value) {
      this.dictBreedStrainCode = "sys_category,name,code,pid=(select id from sys_category where code= '" + value + "')"
      this.model.breedStrainCode = ''
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'breedStrainCode'))
      })
    },
    versionChange(breedStrainCode) {
      //公司
      let companyCode = this.form.getFieldsValue().companyCode
      getVersion({ companyCode: companyCode, breedStrainCode: breedStrainCode }).then((res) => {
        if (res.success) {
          let version = Number(res.result.version) + 1
          this.form.setFieldsValue({
            version: version,
          })
        }
      })
    },
  },
}
</script>

<style scoped>
</style>